import { toteEntity } from "../domain/entities/tote_entity";
import { toteLabelEntity } from "../domain/entities/tote_label_entity";
import http from "../../../plugins/http-common"
import i18n from "../../../i18n";

export const HttpToteRepository = {
  model: toteEntity,
  model_label: toteLabelEntity,

  async index() {
    const res = await http.get('apollo/totes');
    
    return res.data.success.arguments.map(item => ({
      ...item,
      actions: JSON.parse(JSON.stringify([
        {
            name: i18n.t('totes.detail'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            method: 'show',
            permission: "tote.show"
        },
        {
            name: i18n.t('totes.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: 'tote/edit/' + item.id,
            permission: "tote.show"
        },
        {
            name: i18n.t('totes.download_label'),
            icon: {
                color: 'accent',
                icon: 'download_for_offline'
            },
            method: 'downloadLabel',
            permission: "tote.show"
        }
      ])),
      parameters: item
    }));
  },
  async show(id) {
    const res = await http.get('apollo/tote/' + id);
    
    return res.data.success.arguments;
  },
  async update(id, data){
    const res = await http.patch('apollo/tote/' + id, data);

    return res;
  },
  async create(data){
    const res = await http.post('apollo/tote/create', data);

    return res;
  },
  async download_label(id){
    const res = await http.get('apollo/tote/download_label/' + id)

    return res;
  }
};